// Apps a company connects with its own account key (Gamma first). The key goes straight to VERA's server, which checks
// it with the vendor and keeps it in Key Vault under the company's name; Studio only ever learns "connected or not".
import { auth } from "../auth/auth";
import { cpFetch } from "./controlPlane";
import { currentLang } from "./i18n";

export type AppConnection = { app: string; connected: boolean; by?: string | null; at?: string | null };
const token = () => auth.getToken();

export const listApps = () => cpFetch<{ configured: boolean; apps: AppConnection[] }>(token, "/v1/apps");
export const connectApp = (app: string, key: string) => cpFetch(token, `/v1/apps/${app}`, { method: "POST", body: JSON.stringify({ key, language: currentLang() }) });
export const disconnectApp = (app: string) => cpFetch(token, `/v1/apps/${app}`, { method: "DELETE" });
/** Apps connected by signing in with the app (QuickBooks): the server gives the sign-in address, the browser does the rest. */
export const signInAddress = (app: string) => cpFetch<{ url: string }>(token, `/v1/apps/${app}/connect`, { method: "POST" });

export type GammaStatus = { status: "pending" | "completed" | "failed"; gammaUrl?: string | null; exportUrl?: string | null; error?: string | null };

/** Makes a Gamma presentation (or document) from VERA's content, in the company's own Gamma account, and waits for it. */
export async function makeInGamma(text: string, title: string, format: "presentation" | "document" = "presentation", onProgress?: () => void): Promise<GammaStatus> {
  const { generationId } = await cpFetch<{ generationId: string }>(token, "/v1/apps/gamma/generate", { method: "POST", body: JSON.stringify({ text, title, format, language: currentLang() }) });
  // Gamma takes about a minute; ask every 5 seconds, for up to 5 minutes.
  for (let i = 0; i < 60; i++) {
    await new Promise((r) => setTimeout(r, 5000));
    const s = await cpFetch<GammaStatus>(token, `/v1/apps/gamma/generations/${encodeURIComponent(generationId)}`);
    if (s.status !== "pending") return s;
    onProgress?.();
  }
  return { status: "failed", error: currentLang() === "sq" ? "Gamma po vonohet. Shiko te llogaria jote e Gamma pas pak." : "Gamma is taking long. Check your Gamma account in a little while." };
}

let gammaCheck: Promise<boolean> | null = null;
/** Whether this company has Gamma connected (asked once per session; reset when someone connects or disconnects). */
export function gammaConnected(): Promise<boolean> {
  gammaCheck ??= listApps().then((r) => r.apps.some((a) => a.app === "gamma" && a.connected)).catch(() => false);
  return gammaCheck;
}
export const forgetAppStatus = () => { gammaCheck = null; };
